module.exports = __webpack_public_path__ + "static/media/schlafzimmer-2.87bcd010.JPG";